"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _VideoApi = require("./VideoApi");

var _default = function _default(Component) {
  return _react.default.createClass({
    propTypes: {
      block: _react.PropTypes.object.isRequired,
      blockProps: _react.PropTypes.object.isRequired,
      contentState: _react.PropTypes.object.isRequired
    },
    getInitialState: function getInitialState() {
      return {
        nativeURL: null,
        showLoadingOverlay: true,
        videoFound: true,
        vidyardURL: null
      };
    },
    componentWillMount: function componentWillMount() {
      var _this$props = this.props,
          block = _this$props.block,
          contentState = _this$props.contentState;
      var key = block.getEntityAt(0);

      var _contentState$getEnti = contentState.getEntity(key).getData(),
          playerId = _contentState$getEnti.playerId,
          src = _contentState$getEnti.src;

      this.getVideo(playerId, src);
    },
    hideOverlay: function hideOverlay() {
      this.setState({
        showLoadingOverlay: false
      });
    },
    videoFound: function videoFound(vidyardURL) {
      this.setState({
        vidyardURL: vidyardURL,
        videoFound: true
      });
    },
    videoNotFound: function videoNotFound() {
      this.setState({
        videoFound: false
      });
    },
    useNativeVideo: function useNativeVideo(nativeURL) {
      this.setState({
        nativeURL: nativeURL,
        vidyardURL: null,
        showLoadingOverlay: false
      });
    },
    getVideo: function getVideo(playerId, src) {
      if (!playerId) {
        this.useNativeVideo(src);
      }

      if (playerId) {
        this.setState({
          showLoadingOverlay: true,
          nativeURL: null
        });
        (0, _VideoApi.fetchEmbedCodes)(playerId).then(this.videoFound, this.videoNotFound);
      }
    },
    render: function render() {
      var _this$props2 = this.props,
          block = _this$props2.block,
          blockProps = _this$props2.blockProps;
      var _this$state = this.state,
          nativeURL = _this$state.nativeURL,
          showLoadingOverlay = _this$state.showLoadingOverlay,
          videoFound = _this$state.videoFound,
          vidyardURL = _this$state.vidyardURL;
      var key = block.getEntityAt(0);

      if (!key) {
        return null;
      }

      return _react.default.createElement(Component, {
        block: block,
        blockProps: blockProps,
        nativeURL: nativeURL,
        showLoadingOverlay: showLoadingOverlay,
        videoFound: videoFound,
        vidyardURL: vidyardURL,
        getVideo: this.getVideo,
        onVideoLoad: this.hideOverlay
      });
    }
  });
};

exports.default = _default;
module.exports = exports.default;